export default __webpack_public_path__ + "static/media/send.a720e90f.svg";